import "react-datepicker/dist/react-datepicker.css";

import { store } from "../../..";
import "../../../assets/css/majorybl/pages/clubhouse.scss";
import {
    clubhouseActions,
    selectSelectedTeam,
} from "../../../features/clubhouse/clubhouseSlice";
import {
    globalActions,
    selectSetting,
} from "../../../features/global/globalSlice";
import { getTeamSchedule } from "../../../lib/api";
import { ILeague } from "../../../types/api";

const rescheduleGameClubhouseLoader = async ({ params }: any) => {
    const { teamId, gameId } = params;
    let team = selectSelectedTeam(store.getState());

    const user = store.getState().auth.user;
    const settings = store.getState().global.settings;
    const teams = store.getState().clubhouse.teams;
    const fields = store.getState().global.fields;
    const promises = [];

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !teams.length &&
        promises.push(
            store.dispatch(
                clubhouseActions.getTeams({ userId: user?.id as number }),
            ),
        );
    !fields.length && promises.push(store.dispatch(globalActions.getFields()));

    await Promise.all(promises);

    !team && store.dispatch(clubhouseActions.setSelectedTeam(parseInt(teamId)));
    team = team || selectSelectedTeam(store.getState());

    return {
        teamId,
        gameId: parseInt(gameId),
    };
};

export default rescheduleGameClubhouseLoader;
